import { LeftOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Spin } from 'antd';
import bg_home from 'assets/images/bg_home.png';
import bg_home_mb from 'assets/images/bg_home_mb.png';
// import CountDownFinal from 'components/Header/CountDownFinal';
import HeaderMenu from 'components/Header/HeaderMenu';
import HistoryPredictions from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE, SETTING_KEYS } from 'utils/common/const';
import RightGif from '../../components/RightGif';

const leagues = [
  {
    id: 1,
    name: 'UEFA Champions League',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/f/f5/UEFA_Champions_League.svg/960px-UEFA_Champions_League.svg.png'
  },
  {
    id: 2,
    name: 'UEFA Europa League',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/UEFA_Europa_League_logo_%282024_version%29.svg'
  },
  {
    id: 3,
    name: 'English Premier League',
    logo: 'https://loodibee.com/wp-content/uploads/Premier-League-Logo.png'
  },
  {
    id: 4,
    name: 'La Liga',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497700383-85707437.png'
  },
  {
    id: 5,
    name: 'Italian Serie A',
    logo: 'https://1000logos.net/wp-content/uploads/2019/01/Italian-Serie-A-Logo.png'
  },
  {
    id: 6,
    name: 'German Bundesliga',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497741004-506738821.png'
  },
  {
    id: 7,
    name: 'France Ligue 1',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Logo_Ligue_1_McDonald%27s_2024.svg/250px-Logo_Ligue_1_McDonald%27s_2024.svg.png'
  },
  {
    id: 8,
    name: 'England FA Cup',
    logo: '/assets/images/logo/9.png'
  },
  {
    id: 9,
    name: 'International Friendly',
    logo: '/assets/images/logo/13.png'
  }
];

const ScoreStepper = ({ value, onChange, disabled, min = 0, max = 99 }) => {
  const currentValue = value ?? 0;

  const updateValue = (nextValue) => {
    if (nextValue < min || nextValue > max) return;
    onChange?.(nextValue);
  };

  const handleInputChange = (event) => {
    const raw = event.target.value.replace(/\D/g, '').slice(0, 2);

    if (raw === '') {
      onChange?.(undefined);
      return;
    }

    updateValue(Number(raw));
  };

  return (
    <div className="score-stepper flex h-[25px] w-[54px] items-center rounded-[4px] border border-[#D3E3F7] bg-white px-[4px] text-[#0043B3] md:h-[50px] md:w-[108px] md:rounded-[8px] md:px-[8px]">
      <button
        type="button"
        disabled={disabled || currentValue <= min}
        onClick={() => updateValue(currentValue - 1)}
        className="flex h-[25px] w-[13px] shrink-0 items-center justify-center border-0 bg-transparent text-[11px] font-bold leading-none text-[#0043B3] disabled:cursor-not-allowed disabled:opacity-40 md:h-[50px] md:w-[25px] md:text-[21px]"
      >
        -
      </button>
      <input
        type="text"
        inputMode="numeric"
        disabled={disabled}
        value={value === undefined || value === null || value === '' ? '' : String(value)}
        onChange={handleInputChange}
        placeholder="0"
        className="h-[25px] w-[25px] shrink-0 border-0 bg-transparent text-center text-[17px] font-bold leading-none text-[#0043B3] outline-none placeholder:text-[#0043B3] md:h-[50px] md:w-[50px] md:text-[33px]"
      />
      <button
        type="button"
        disabled={disabled || currentValue >= max}
        onClick={() => updateValue(currentValue + 1)}
        className="flex h-[25px] w-[13px] shrink-0 items-center justify-center border-0 bg-transparent text-[11px] font-bold leading-none text-[#0043B3] disabled:cursor-not-allowed disabled:opacity-40 md:h-[50px] md:w-[25px] md:text-[21px]"
      >
        +
      </button>
    </div>
  );
};

const renderMatchCountdown = (compact = false) =>
  function MatchCountdown({ days, hours, minutes, seconds, completed }) {
    if (completed) {
      return compact ? null : <span className="text-[14px] font-medium">Hết giờ</span>;
    }

    const pad = (n) => n.toString().padStart(2, '0');
    const totalHours = (days || 0) * 24 + (hours || 0);

    if (compact) {
      return (
        <div className="flex items-start rounded-[5px] bg-[#0043B3] p-[2px] text-white">
          <div className="flex w-[16px] flex-col items-center">
            <span className="text-[12px] font-bold leading-none">{pad(totalHours)}</span>
            <span className="text-[6px] leading-none">GIỜ</span>
          </div>
          <span className="px-[1px] text-[12px] font-bold leading-none">:</span>
          <div className="flex w-[16px] flex-col items-center">
            <span className="text-[12px] font-bold leading-none">{pad(minutes)}</span>
            <span className="text-[6px] leading-none">PHÚT</span>
          </div>
          <span className="px-[1px] text-[12px] font-bold leading-none">:</span>
          <div className="flex w-[16px] flex-col items-center">
            <span className="text-[12px] font-bold leading-none">{pad(seconds)}</span>
            <span className="text-[6px] leading-none">GIÂY</span>
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-start justify-center">
        <div className="flex w-[46px] flex-col items-center md:w-[57px]">
          <span className="text-[24px] font-bold leading-none md:text-[32px]">
            {pad(totalHours)}
          </span>
          <span className="mt-1 text-[10px] md:text-[11px]">GIỜ</span>
        </div>
        <span className="px-1 text-[24px] font-bold leading-none md:text-[32px]">:</span>
        <div className="flex w-[46px] flex-col items-center md:w-[57px]">
          <span className="text-[24px] font-bold leading-none md:text-[32px]">{pad(minutes)}</span>
          <span className="mt-1 text-[10px] md:text-[11px]">PHÚT</span>
        </div>
        <span className="px-1 text-[24px] font-bold leading-none md:text-[32px]">:</span>
        <div className="flex w-[46px] flex-col items-center md:w-[57px]">
          <span className="text-[24px] font-bold leading-none md:text-[32px]">{pad(seconds)}</span>
          <span className="mt-1 text-[10px] md:text-[11px]">GIÂY</span>
        </div>
      </div>
    );
  };

const OK9Page = () => {
  const [isModalHistory, setIsModalHistory] = useState(false);
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow'
  const [showSchedulePopup, setShowSchedulePopup] = useState(false);

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();
  }, []);

  useEffect(() => {
    fetchDataScheduByLS();
  }, []);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchDataScheduByLS = async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.OK9
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.OK9 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (predictions) => {
    return Promise.race([
      createPredictions(predictions),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Validate that both home and away scores are provided for each match
      const hasInvalidScores = Object.entries(data).some(([key, value]) => {
        // Bỏ qua field account và các field không phải score
        if (key === 'account' || !key.includes('_')) return false;

        const parts = key.split('_');
        if (parts.length !== 2) return false;

        const [scoreType, matchId] = parts;
        if (!['homeScore', 'awayScore'].includes(scoreType)) return false;

        const otherScoreType = scoreType === 'homeScore' ? 'awayScore' : 'homeScore';
        const otherScoreKey = `${otherScoreType}_${matchId}`;
        const otherValue = data[otherScoreKey];

        // Kiểm tra nếu một trong hai score có giá trị nhưng score kia không có
        const hasValue = value !== undefined && value !== null && value !== '';
        const hasOtherValue = otherValue !== undefined && otherValue !== null && otherValue !== '';

        if (hasValue && !hasOtherValue) {
          return true;
        }

        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập đầy đủ cả hai bên tỉ số cho mỗi trận đấu!'
        });
        return;
      }

      setIsLoadingSubmit(true);

      console.log('filteredMatches', filteredMatches);
      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng dự đoán ít nhất một trận đấu!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      const res = await createPredictionsWithTimeout(resultGroup);
      if (res?.code === 0) {
        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo) => {
    const groupedMatches = Object.entries(input).reduce((acc, [key, value]) => {
      if (key === 'account') return acc;

      const parts = key.split('_');
      if (parts.length !== 2) return acc;

      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore', 'sameScore'].includes(scoreType)) return acc;

      // Kiểm tra giá trị hợp lệ
      if (value === undefined || value === null || value === '') return acc;

      if (!acc[matchId]) {
        acc[matchId] = {
          matchId,
          account: input.account,
          homeScore: undefined,
          awayScore: undefined,
          sameScore: undefined
        };
      }

      if (scoreType === 'homeScore') {
        acc[matchId].homeScore = value;
      } else if (scoreType === 'awayScore') {
        acc[matchId].awayScore = value;
      } else if (scoreType === 'sameScore') {
        acc[matchId].sameScore = value;
      }

      return acc;
    }, {});

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          match.sameScore !== null &&
          match.homeScore !== '' &&
          match.sameScore !== '' &&
          match.awayScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore, sameScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );

        return {
          matchId,
          homeScore,
          awayScore,
          sameScore,
          account,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const filterTabClass = (isActive) =>
    twMerge(
      'flex h-[26px] min-w-0 flex-1 shrink-0 items-center justify-center rounded-[32px] border px-[6px] text-[11px] font-medium capitalize leading-none whitespace-nowrap transition-all duration-200 md:h-[40px] md:w-[130px] md:flex-none md:rounded-[50px] md:px-[10px] md:text-[16px]',
      isActive
        ? 'border-white bg-gradient-to-b from-[#237AF6] to-[#0B4FD6] text-white'
        : 'border-[#D3E3F7] bg-gradient-to-b from-white to-[#EBF4FF] text-[#0043B3] hover:opacity-90'
    );

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return <p>{dataSettings?.find((item) => item.key === SETTING_KEYS.NO_DATA)?.content}</p>;
    } else {
      const filteredMatchList =
        selectedLeagues.length > 0
          ? matchList.filter((item) =>
              selectedLeagues.includes(
                leagues.find(
                  (league) =>
                    league.name === item.leagueName || item.leagueName.startsWith(league.name)
                )?.id
              )
            )
          : matchList;

      const itemMatch = filteredMatchList
        .filter((item) => timeServer <= item.countdown) // Filter out matches that have ended
        .map((item, index) => {
          // const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')]; // Calculate day of week for each match
          return (
            <div
              className={twMerge(
                'relative mx-auto mt-3 w-full overflow-hidden rounded-[15px] border border-[#D3E3F7]',
                timeServer > item.countdown ? 'contrast-50' : ''
              )}
              key={index}
            >
              <div className="pointer-events-none absolute inset-0 rounded-[15px] bg-white" />
              <img
                src="assets/images/match/bg_mb.png"
                alt=""
                className="absolute inset-0 h-full w-full object-cover md:hidden"
              />
              <img
                src="assets/images/match/bg.png"
                alt=""
                className="absolute inset-0 hidden h-full w-full object-cover md:block"
              />
              <div className="absolute left-1/2 top-0 z-[2] flex -translate-x-1/2 items-center justify-center rounded-b-[14px] bg-gradient-to-b from-[#237AF6] to-[#0B4FD6] px-6 py-1.5 md:left-0 md:translate-x-0 md:rounded-br-[18px] md:rounded-bl-none md:px-8 md:py-2.5">
                <p className="max-w-[180px] truncate text-[13px] font-medium capitalize leading-none text-white md:max-w-none md:text-[20px]">
                  {item?.leagueName || ''}
                </p>
              </div>

              <div className="relative z-[1] flex min-h-[201px] flex-col md:min-h-0 md:items-center md:gap-5 md:px-6 md:py-6">
                <div className="mt-8 hidden w-full max-w-[251px] flex-col items-center gap-[9px] rounded-[15px] border border-[#D3E3F7] bg-white p-[10px] text-center text-[#0043B3] md:mt-10 md:flex">
                  <p className="text-[12px] font-bold leading-none">THỜI GIAN DỰ ĐOÁN CÒN LẠI</p>
                  <Countdown date={item.countdown} renderer={renderMatchCountdown(false)} />
                </div>

                <div className="flex w-full mx-auto justify-center items-end gap-[3px] px-0 pt-8 md:items-center md:gap-6 md:px-0 md:pt-0 lg:gap-10">
                  <div className="flex min-w-0 flex-1 flex-col items-center justify-end gap-[6px] pb-[10px] md:w-[148px] md:flex-none md:gap-2 md:pb-0">
                    <img
                      src={item.homeLogo}
                      className="h-[70px] w-[70px] object-contain md:h-[110px] md:w-[110px]"
                      alt=""
                    />
                    <p className="line-clamp-2 w-full text-center text-[11px] font-medium uppercase leading-tight text-[#0043B3] md:line-clamp-none md:text-[19px]">
                      {item.homeName}
                    </p>
                  </div>

                  <div className="flex w-[188px] shrink-0 flex-col items-center gap-[5px] pb-[10px] md:w-auto md:pb-0">
                    <div className="flex w-full items-center justify-between md:w-auto md:justify-center md:gap-6">
                      <Form.Item className="m-0 p-0" name={`homeScore_${item.matchId}`}>
                        <ScoreStepper disabled={timeServer > item.countdown} />
                      </Form.Item>
                      <img
                        src="/assets/images/match/vs.png"
                        className="h-[26px] w-[40px] shrink-0 object-contain md:h-[66px] md:w-[105px]"
                        alt=""
                      />
                      <Form.Item className="m-0 p-0" name={`awayScore_${item.matchId}`}>
                        <ScoreStepper disabled={timeServer > item.countdown} />
                      </Form.Item>
                    </div>
                    <div className="flex h-[27px] w-full items-center gap-[7px] rounded-[5px] border border-[#D3E3F7] bg-white px-[14px] md:h-[40px] md:max-w-[276px] md:rounded-[100px] md:px-[20px]">
                      <img
                        src="/assets/images/match/people.png"
                        alt=""
                        className="h-[18px] w-[18px] shrink-0 object-contain md:h-[23px] md:w-[23px]"
                      />
                      <Form.Item
                        className="m-0 min-w-0 flex-1 p-0"
                        name={`sameScore_${item.matchId}`}
                      >
                        <InputNumber
                          disabled={timeServer > item.countdown}
                          controls={false}
                          min={0}
                          maxLength={5}
                          bordered={false}
                          placeholder="Số người dự đoán giống bạn"
                          className="same-score-input same-score-input--mobile w-full"
                        />
                      </Form.Item>
                    </div>
                  </div>

                  <div className="flex min-w-0 flex-1 flex-col items-center justify-end gap-[6px] pb-[10px] md:w-[148px] md:flex-none md:gap-2 md:pb-0">
                    <img
                      src={item.awayLogo}
                      className="h-[70px] w-[70px] object-contain md:h-[110px] md:w-[110px]"
                      alt=""
                    />
                    <p className="line-clamp-2 w-full text-center text-[11px] font-medium uppercase leading-tight text-[#0043B3] md:line-clamp-none md:text-[19px]">
                      {item.awayName}
                    </p>
                  </div>
                </div>

                <div className="mt-auto flex flex-col items-center gap-[5px] px-2 pb-2 pt-1 md:mt-0 md:gap-2 md:px-0 md:pb-0 md:pt-0">
                  <Button
                    type="none"
                    htmlType="submit"
                    disabled={timeServer > item.countdown}
                    className="relative flex h-[33px] w-[177px] items-center justify-center rounded-full border-0 bg-[#2F6EFF] text-[15px] font-medium capitalize leading-none text-white shadow-none hover:!bg-[#2F6EFF] md:h-[44px] md:w-full md:max-w-[238px] md:text-[20px]"
                    style={{
                      boxShadow: 'inset -2px -3px 5px 0px rgba(255,255,255,0.15)'
                    }}
                  >
                    Gửi dự đoán
                  </Button>

                  <div className="flex w-full max-w-[345px] items-center justify-between gap-2 md:hidden">
                    <div className="flex min-w-0 items-center gap-1">
                      <img
                        src="/assets/images/match/timer.png"
                        alt=""
                        className="h-[16px] w-[16px] shrink-0 object-contain"
                      />
                      <p className="text-[10px] leading-tight text-[#768195]">
                        Trước{' '}
                        <span className="font-bold text-[#0043B3]">
                          {dayjs(item.startTime * 1000).format('HH:mm')}
                        </span>{' '}
                        ngày{' '}
                        <span className="font-bold text-[#0043B3]">
                          {dayjs(item.startTime * 1000).format('DD/MM/YYYY')}
                        </span>
                      </p>
                    </div>
                    <div className="flex shrink-0 items-center gap-1">
                      <span className="whitespace-nowrap text-[10px] text-[#768195]">
                        Thời gian còn lại:
                      </span>
                      <Countdown date={item.countdown} renderer={renderMatchCountdown(true)} />
                    </div>
                  </div>

                  <p className="hidden text-center text-[14px] text-[#768195] md:block">
                    Trước{' '}
                    <span className="font-bold text-[#0043B3]">
                      {dayjs(item.startTime * 1000).format('HH:mm')}
                    </span>{' '}
                    ngày{' '}
                    <span className="font-bold text-[#0043B3]">
                      {dayjs(item.startTime * 1000).format('DD/MM/YYYY')}
                    </span>
                  </p>
                </div>
              </div>
              <div className="pointer-events-none absolute inset-0 z-[3] rounded-[15px] shadow-[inset_0px_0px_4px_0px_#1c6dec]" />
            </div>
          );
        });
      return itemMatch;
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home_mb}
        alt="Background"
        className="fixed top-0 left-0 h-full w-full object-cover object-top md:hidden"
      />
      <img
        src={bg_home}
        alt="Background"
        className="fixed top-0 left-0 hidden h-full w-full object-cover object-top md:block"
      />
      <RightGif />
      <div className="container relative z-10">
        <div className="relative z-0">
          <HeaderMenu />
        </div>

        <div className="relative z-10 mx-auto flex w-full flex-col gap-[20px] md:rounded-[20px] bg-transparent md:bg-white p-[12px] md:gap-[31px] md:p-[30px]">
          <div className="flex w-full items-stretch overflow-hidden rounded-[14px] border border-solid border-[#D3E3F7] bg-white">
            <button
              type="button"
              onClick={scrollLeft}
              className="flex h-[72px] w-[36px] shrink-0 items-center justify-center border-0 bg-transparent text-[#0043B3] md:h-[108px] md:w-[44px]"
            >
              <LeftOutlined className="text-[18px] md:text-[22px]" />
            </button>
            <div
              className="scrollbar-hide flex min-w-0 flex-1 items-center overflow-x-auto overflow-y-hidden"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league, index) => (
                <React.Fragment key={league.id}>
                  {index > 1 && (
                    <div className="my-auto h-[32px] w-px shrink-0 bg-gradient-to-b from-transparent via-[#D3E3F7] to-transparent md:h-[46px]" />
                  )}
                  <div
                    className={twMerge(
                      'flex h-[72px] w-[82px] shrink-0 cursor-pointer items-center justify-center overflow-hidden transition-all duration-200 md:h-[108px] md:w-[148px]',
                      selectedLeagues.includes(league.id)
                        ? 'bg-[rgba(0,83,223,0.1)]'
                        : 'bg-white hover:bg-[#F5F9FF]'
                    )}
                    onClick={() => handleLeagueClick(league.id)}
                  >
                    <img
                      src={league.logo}
                      alt={league.name}
                      className="h-[40px] w-[60px] object-contain md:h-[70px] md:w-[96px]"
                    />
                  </div>
                </React.Fragment>
              ))}
            </div>
            <button
              type="button"
              onClick={scrollRight}
              className="flex h-[72px] w-[36px] shrink-0 items-center justify-center border-0 bg-transparent text-[#0043B3] md:h-[108px] md:w-[44px]"
            >
              <RightOutlined className="text-[18px] md:text-[22px]" />
            </button>
          </div>

          <Form
            name="formMatch"
            onFinish={onFinishForm}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            form={form}
            initialValues={{ account: '' }}
          >
            <div className="flex w-full -mt-2 md:mt-0 flex-col gap-3 xl:flex-row xl:items-center xl:gap-6">
              <div className="flex w-full flex-nowrap items-center gap-[7px] xl:flex-1 xl:gap-[11px]">
                <button
                  type="button"
                  onClick={() => setActiveTab('all')}
                  className={filterTabClass(activeTab === 'all')}
                >
                  Tất cả
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab('today')}
                  className={filterTabClass(activeTab === 'today')}
                >
                  Hôm nay
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab('tomorrow')}
                  className={filterTabClass(activeTab === 'tomorrow')}
                >
                  Ngày mai
                </button>
                <button
                  type="button"
                  onClick={() => setShowSchedulePopup(true)}
                  className={filterTabClass(false)}
                >
                  Lịch thi đấu
                </button>
              </div>

              <div className="account-field flex w-full shrink-0 items-stretch overflow-hidden rounded-[50px] border border-solid border-[#D3E3F7] xl:max-w-[391px]">
                <Form.Item name="account" className="account-field__input mb-0 min-w-0 flex-1">
                  <Input
                    placeholder="Nhập tên đăng nhập"
                    maxLength={20}
                    variant="borderless"
                    prefix={<UserOutlined className="text-[#768195]" />}
                    className="h-[40px] bg-white text-[14px] text-[#768195] shadow-none"
                  />
                </Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoadingSubmit}
                  className="h-[40px] w-[115px] shrink-0 rounded-none rounded-br-[50px] rounded-tr-[50px] border-0 bg-gradient-to-b from-[#237AF6] to-[#0B4FD6] px-[20px] text-[14px] font-bold text-white hover:!from-[#237AF6] hover:!to-[#0B4FD6]"
                >
                  Xác nhận
                </Button>
              </div>
            </div>

            <div className="md:mt-[25px] mt-[4px] w-full">
              {isLoading ? (
                <div className="w-full py-8 text-center">
                  <Spin />
                </div>
              ) : (
                <div className="flex w-full flex-col md:gap-[20px] gap-[2px]">
                  {showListItemMatch(getFilteredMatches())}
                </div>
              )}
            </div>
          </Form>
        </div>
      </div>

      {/* Popup Lịch Thi Đấu */}
      {showSchedulePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between p-4">
              <h2 className="text-xl font-bold text-[#0053df]">LỊCH THI ĐẤU HOT</h2>
              <button
                onClick={() => setShowSchedulePopup(false)}
                className="w-8 h-8 bg-[#568be3] text-white rounded-full flex items-center justify-center hover:bg-[#4887f0] transition-colors"
              >
                ×
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <iframe
                src="https://football-widget.pages.dev/"
                width="100%"
                height="600"
                frameBorder="0"
                allowFullScreen
                title="Football Widget"
                className="w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default OK9Page;
